import exportTranscript from './exportTranscript';

export default exportTranscript;
